import axios from "axios";
import store from "../redux/store";

const baseUrl = String(process.env.REACT_APP_API_URL);

let isRefreshing = false;
let refreshPromise = null;

axios.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem(
      "accessToken" + process.env.REACT_APP_LS_SALT
    );
    if (accessToken) {
      config.headers = {
        Authorization: `Bearer ${accessToken}`,
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      };
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    let refreshToken = localStorage.getItem(
      "refreshToken" + process.env.REACT_APP_LS_SALT
    );
    if (
      refreshToken &&
      error.response.status === 440 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      if (!isRefreshing) {
        isRefreshing = true;
        refreshPromise = axios
          .post(`${baseUrl}/auth/refresh`, { refreshToken: refreshToken })
          .then((res) => {
            if (res.status === 200) {
              localStorage.setItem(
                "accessToken" + process.env.REACT_APP_LS_SALT,
                res.data.accessToken
              );
              localStorage.setItem(
                "refreshToken" + process.env.REACT_APP_LS_SALT,
                res.data.refreshToken
              );
            }
          })
          .catch((e) => {
            if (e.response.status === 400 || e.response.status === 401) {
              store.dispatch({
                type: "auth/logout",
              });
            }
            return Promise.reject(e);
          })
          .finally(() => {
            isRefreshing = false;
            refreshPromise = null;
          });
      }

      try {
        await refreshPromise;
      } catch (e) {
        return Promise.reject(e);
      }

      return axios(originalRequest);
    }
    return Promise.reject(error);
  }
);

const api = {
  login: (body) => {
    return axios.post(`${baseUrl}/auth`, body);
  },
  checkAuth: () => {
    return axios.post(`${baseUrl}/auth/check`);
  },
  datosUsuario: () => {
    return axios.post(`${baseUrl}/auth/usuario`);
  },
  menuUsuario: () => {
    return axios.post(`${baseUrl}/auth/menu`);
  },
  accionesUsuario: () => {
    return axios.post(`${baseUrl}/auth/acciones`);
  },
  ping: () => {
    return axios.post(`${baseUrl}/ping`);
  },
  bandejaEntrada: (body) => {
    return axios.post(`${baseUrl}/bandeja_entrada`, body);
  },
  verTramiteAdmin: (body) => {
    return axios.post(`${baseUrl}/tramite_admin_ver`, body);
  },
  buscarPersonaFisica: (body) => {
    return axios.post(`${baseUrl}/buscar_persona_fisica`, body);
  },
  buscarPersonaJuridica: (body) => {
    return axios.post(`${baseUrl}/buscar_persona_juridica`, body);
  },
  buscarTema: (body) => {
    return axios.post(`${baseUrl}/buscar_tema`, body);
  },
  buscarOrganismo: (body) => {
    return axios.post(`${baseUrl}/buscar_organismo`, body);
  },
  listarMinisterios: (body) => {
    return axios.post(`${baseUrl}/listar_ministerios`, body);
  },
  guardarTramite: (body) => {
    return axios.post(`${baseUrl}/alta_tramite`, body);
  },
  buscarProvincias: (body) => {
    return axios.post(`${baseUrl}/provincias`, body);
  },
  buscarDepartamentos: (body) => {
    return axios.post(`${baseUrl}/departamentos_por_provincia`, body);
  },
  buscarLocalidades: (body) => {
    return axios.post(`${baseUrl}/localidades_por_departamento`, body);
  },
  listarEstadosTramite: () => {
    return axios.post(`${baseUrl}/listar_estados_tramite`);
  },
  actualizarEmailIniciador: (body) => {
    return axios.post(`${baseUrl}/actualizar_email_iniciador`, body);
  },
  listarDecisionesAdministrativas: (body) => {
    return axios.post(
      `${baseUrl}/listar_tipos_decisiones_administrativas`,
      body
    );
  },
  buscarAdjuntosTramites: (body) => {
    return axios.post(`${baseUrl}/buscar_adjuntos_tramite`, body);
  },
  buscarMovimiento: (body) => {
    return axios.post(`${baseUrl}/listar_movimientos`, body);
  },
  buscarTiposInformes: (body) => {
    return axios.post(`${baseUrl}/listar_tipos_informes`, body);
  },
  buscarVisibilidad: (body) => {
    return axios.post(`${baseUrl}/buscar_visibilidad`, body);
  },
  recepcionarMovimiento: (body) => {
    return axios.post(`${baseUrl}/registrar_recepcion`, body);
  },
  eliminarMovimiento: (body) => {
    return axios.post(`${baseUrl}/movimiento_borra`, body);
  },
  eliminarRecepcion: (body) => {
    return axios.post(`${baseUrl}/eliminar_recepcion`, body);
  },
  obtenerVolante: (body) => {
    return axios.post(`${baseUrl}/generar_volante`, body);
  },
  obtenerFicha: (body) => {
    return axios.post(`${baseUrl}/generar_ficha`, body);
  },
  consultaMulticriterios: (body) => {
    return axios.post(`${baseUrl}/consulta_multicriterios`, body);
  },
  eliminarAdjuntoTramite: (body) => {
    return axios.post(`${baseUrl}/eliminar_adjunto_tramite`, body);
  },
  guardarAdjuntoTramite: (body) => {
    return axios.post(`${baseUrl}/guardar_adjunto_tramite`, body);
  },
  buscarPermisoAdjuntos: (body) => {
    return axios.post(`${baseUrl}/consultar_permiso_adjunto_tramite`, body);
  },
  buscarAdjuntosId: (body) => {
    return axios.post(`${baseUrl}/buscar_adjunto_id`, body);
  },
  buscarPermisoAgregarAdjuntos: (body) => {
    return axios.post(
      `${baseUrl}/consultar_permiso_agregar_adjunto_tramite`,
      body
    );
  },
  obtenerCaratula: (body) => {
    return axios.post(`${baseUrl}/generar_caratula`, body);
  },
  firmarAdjunto: (body) => {
    return axios.post(`${baseUrl}/firma_remota_adjunto`, body);
  },
  verificarFirmaAdjunto: (body) => {
    return axios.post(`${baseUrl}/verificar_firma_adjunto`, body);
  },
  registrarMovimiento: (body) => {
    return axios.post(`${baseUrl}/registrar_movimiento`, body);
  },
  generarTramite: (body) => {
    return axios.post(`${baseUrl}/generar_tramite`, body);
  },
  buscarTramiteId: (body) => {
    return axios.post(`${baseUrl}/buscar_tramite_id`, body);
  },
  generarZip: (body) => {
    return axios.post(`${baseUrl}/generar_zip`, body);
  },
  buscarAgregadosTramites: (body) => {
    return axios.post(`${baseUrl}/buscar_agregados_tramite`, body);
  },
  registrarEstado: (body) => {
    return axios.post(`${baseUrl}/registrar_estado`, body);
  },
  verCaratula: (body) => {
    return axios.post(`${baseUrl}/ver_caratula`, body);
  },
  verCantidadAdjuntos: (body) => {
    return axios.post(`${baseUrl}/ver_cantidad_adjuntos`, body);
  },
  seguimientoTramites: (body) => {
    return axios.post(`${baseUrl}/buscar_entrada_salida`, body);
  },
  registrarArchivado: (body) => {
    return axios.post(`${baseUrl}/registrar_archivado`, body);
  },
  listarIniciadores: (body) => {
    return axios.post(`${baseUrl}/obtener_iniciadores`, body);
  },
  listarArchivados: (body) => {
    return axios.post(`${baseUrl}/listar_archivados`, body);
  },
  reporteSeguimiento: (body) => {
    return axios.post(`${baseUrl}/reporte_seguimiento`, body);
  },
  guardarMovimientoExpedientes: (body) => {
    return axios.post(`${baseUrl}/registrar_movimiento_expedientes`, body);
  },
  reporteArchivados: (body) => {
    return axios.post(`${baseUrl}/reporte_archivados`, body);
  },
  guardarAgregado: (body) => {
    return axios.post(`${baseUrl}/registrar_agregado`, body);
  },
  obtenerNotificaciones: () => {
    return axios.post(`${baseUrl}/notificaciones`);
  },
  marcarLeidas: () => {
    return axios.post(`${baseUrl}/notificaciones/leer`);
  },
  eliminarAgregado: (body) => {
    return axios.post(`${baseUrl}/eliminar_agregado`, body);
  },
  guardarDesglose: (body) => {
    return axios.post(`${baseUrl}/registrar_desglose`, body);
  },
  firmarAdjuntoToken: (body) => {
    return axios.post(`${baseUrl}/firma_token_adjunto`, body);
  },
  consultaExpediente: (body) => {
    return axios.post(`${baseUrl}/buscar_expediente`, body);
  },
  eliminarDesglose: (body) => {
    return axios.post(`${baseUrl}/eliminar_desglose`, body);
  },
  recepcionarMovimientoConFecha: (body) => {
    return axios.post(`${baseUrl}/registrar_recepcion_con_fecha`, body);
  },
  editarTramite: (body) => {
    return axios.post(`${baseUrl}/editar_tramite`, body);
  },
  editarArchivado: (body) => {
    return axios.post(`${baseUrl}/editar_archivo`, body);
  },
  recircular: (body) => {
    return axios.post(`${baseUrl}/recircular`, body);
  },
  eliminarTramite: (body) => {
    return axios.post(`${baseUrl}/eliminar_tramite`, body);
  },
  estadoSuscripcion: (body) => {
    return axios.post(`${baseUrl}/estado_suscripcion`, body);
  },
  suscribir: (body) => {
    return axios.post(`${baseUrl}/suscribir`, body);
  },
  desuscribir: (body) => {
    return axios.post(`${baseUrl}/desuscribir`, body);
  },
  actualizarEmailIniciadorOrganismo: (body) => {
    return axios.post(`${baseUrl}/actualizar_email_iniciador_organismo`, body);
  },
  verificarUltimoAdjunto: (body) => {
    return axios.get(`${baseUrl}/adjunto_validar_ultimo`, { params: body });
  },
  notificarAdjuntoTramite: (body) => {
    return axios.post(`${baseUrl}/notificar_adjunto_tramite`, body);
  },
  consultaExpedientes: (body) => {
    return axios.post(`${baseUrl}/buscar_expedientes`, body);
  },
  consultaSuscripciones: (body) => {
    return axios.get(`${baseUrl}/buscar_suscripciones`, { params: body });
  },
  obtenerPlantilla: (body) => {
    return axios.get(`${baseUrl}/obtener_plantilla`, { params: body });
  },
  buscarGrupos: (body) => {
    return axios.get(`${baseUrl}/grupos`, { params: body });
  },
  obtenerVsibilidades: (body) => {
    return axios.get(`${baseUrl}/visibilidades`, { params: body });
  },
  obtenerGruposPadresAutocomplete: (body) => {
    return axios.get(`${baseUrl}/grupos/autocomplete`, { params: body });
  },
  guardarGrupo: (body) => {
    return axios.post(`${baseUrl}/grupos/guardar`, body);
  },
  obtenerGrupo: (body) => {
    return axios.get(`${baseUrl}/grupos/datos`, { params: body });
  },
  obtenerOrganismosGrupo: (body) => {
    return axios.get(`${baseUrl}/grupos/organismos`, { params: body });
  },
  obtenerOrganismosGrupoActor: () => {
    return axios.get(`${baseUrl}/grupos/organismos/actor`);
  },
  agregarOrganismoGrupo: (body) => {
    return axios.post(`${baseUrl}/grupos/organismo/agregar`, body);
  },
  transferirOrganismoGrupo: (body) => {
    return axios.post(`${baseUrl}/grupos/organismo/transferir`, body);
  },
  marcarMesaEntrada: (body) => {
    return axios.post(`${baseUrl}/grupos/organismo/entrada`, body);
  },
  buscarActoresOrganismo: (body) => {
    return axios.get(`${baseUrl}/organismo/actores`, { params: body });
  },
  obtenerOrganismosSinAsignarAutocomplete: (body) => {
    return axios.get(`${baseUrl}/grupos/organismos/autocomplete`, {
      params: body,
    });
  },
  buscarOrganismoUltimo: (body) => {
    return axios.get(`${baseUrl}/buscar_organismo_ultimo`, { params: body });
  },
  busqueda_gerencial: (body) => {
    return axios.get(`${baseUrl}/busqueda_consulta_gerencial`, { params: body });
  }, 
  desplegarGerencial: (body) => {
    return axios.get(`${baseUrl}/desplegarGerencial`, { params: body });
  },
  
  guardarIniciador: (body) => {
    return axios.post(`${baseUrl}/agregar_iniciador`, body);
  },
  eliminarIniciador: (body) => {
    return axios.post(`${baseUrl}/eliminar_iniciador`, body);
  },
  
  
};

export default api;
